export const LOAN_STATUS_ACTIVE = "[2,3,4]";
export const LOAN_STATUS_DISBURSEMENT = "[1,8]";
export const LOAN_STATUS_DRAFTS = "10";
export const LOAN_STATUS_APPLICATIONS = "[0,9]";
export const LOAN_STATUS_CLOSED = "5";
export const LOAN_STATUS_DECLINED = "6";
export const LOAN_STATUS_WRITTEN_OFF = "7";

export const LOAN_TYPES = [
  { name: "Active Loans", value: LOAN_STATUS_ACTIVE },
  { name: "Loan Disbursement", value: LOAN_STATUS_DISBURSEMENT },
  { name: "Drafts", value: LOAN_STATUS_DRAFTS },
  { name: "Loan Applications", value: LOAN_STATUS_APPLICATIONS },
  { name: "Closed Loans", value: LOAN_STATUS_CLOSED },
  { name: "Written Off Loans", value: LOAN_STATUS_WRITTEN_OFF },
  { name: "Declined Loans", value: LOAN_STATUS_DECLINED },
];

export const LOAN_COLLATERAL_TYPES = [
  {
    name: "Cash Collateral",
    value: "cash_collateral",
  },
  {
    name: "Electronics",
    value: "electronics",
  },
  {
    name: "Cars",
    value: "cars",
  },
  {
    name: "Land Titles",
    value: "land_titles",
  },
];

export const LOAN_PURPOSES = [
  {
    name: "Home Improvement",
    value: "home_improvement",
  },
  {
    name: "Education",
    value: "education",
  },
  {
    name: "Medical Expenses",
    value: "medical_expenses",
  },
  {
    name: "Business Expansion",
    value: "business_expansion",
  },
  {
    name: "Debt Consolidation",
    value: "debt_consolidation",
  },
  {
    name: "Vehicle Purchase",
    value: "vehicle_purchase",
  },
  {
    name: "Agricultural Investment",
    value: "agricultural_investment",
  },
  {
    name: "Emergency Expenses",
    value: "emergency_expenses",
  },
  {
    name: "Wedding or Event Expenses",
    value: "wedding_or_event_expenses",
  },
  {
    name: "Vacation or Travel",
    value: "vacation_or_travel",
  },
  {
    name: "Rent or Mortgage Payments",
    value: "rent_or_mortgage_payments",
  },
  {
    name: "Technology or Electronics Purchase",
    value: "technology_or_electronics_purchase",
  },
  {
    name: "Investment",
    value: "investment",
  },
  {
    name: "Business Start-Up Capital",
    value: "business_start_up_capital",
  },
  {
    name: "Other",
    value: "other",
  },
];

export const getLoanPurpose = (value: string) => {
  const loanPurpose = LOAN_PURPOSES.find((purpose) => purpose.value === value);
  return loanPurpose ? loanPurpose.name : "";
};

export const COLLATERAL_TYPES = [
  {
    name: "CONCESSIONS",
    value: 1,
  },
  {
    name: "GUARANTEE COLL",
    value: 3,
  },
  {
    name: "MOTOR VEHICLE",
    value: 4,
  },
  {
    name: "NEGATIVE PLEDGE",
    value: 5,
  },
  {
    name: "NON FINANCIAL ASSETS",
    value: 6,
  },
  {
    name: "FINANCIAL ASSETS",
    value: 7,
  },
  {
    name: "PLANT AND MACHINERY",
    value: 8,
  },
  {
    name: "PROPERTIES MORTGAGE",
    value: 9,
  },
  {
    name: "QUOTED SHARES",
    value: 10,
  },
  {
    name: "SUPPORTIVE LETTERS",
    value: 11,
  },
  {
    name: "UNIT TRUSTS",
    value: 13,
  },
  {
    name: "UNQUOTED SHARES",
    value: 14,
  },
  {
    name: "CHATTEL",
    value: 15,
  },
];

export const formatLoanRepaymentFees = (fees: any) => {
  return fees.map((fee: any) => ({
    id: fee?.id,
    name: fee?.name,
    paymentType: fee?.paymenttype || fee?.paymentType || "",
    chargeAmount: fee?.charge_amount || fee?.chargeAmount || 0,
  }));
};
